var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0629 14.4369V16.1556C13.0629 16.6115 12.8818 17.0487 12.5595 17.371C12.2372 17.6933 11.8 17.8744 11.3442 17.8744H4.46918C4.01334 17.8744 3.57617 17.6933 3.25384 17.371C2.93151 17.0487 2.75043 16.6115 2.75043 16.1556V5.84314C2.75043 5.3873 2.93151 4.95013 3.25384 4.6278C3.57617 4.30547 4.01334 4.12439 4.46918 4.12439H11.0004C11.9496 4.12439 13.0629 4.89396 13.0629 5.84314V7.56189",
    stroke: "#616161",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.812 14.4384L19.25 11.0004L15.812 7.56238",
    stroke: "#616161",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56171 10.9996H18.5617",
    stroke: "#616161",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic-logout.88648665d95e835fffc16c9a13de35fa.svg";
export { ForwardRef as ReactComponent };